export const INITIAL_INSURANCE_CARD_STATE = {
  url: null,
  thumbMin: null,
  thumbMiddle: null,
  thumbLarge: null,
};



// WEBPACK FOOTER //
// ./src/constants/insurance/initial-insurance-card-state.js